/**
 * @desc 分页
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.LogisticsGroupResponseDto>
>;
export function request(
  params: API.basics.logisticsGroup.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/logisticsGroup/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
